///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/components/presenters/labels/defaults"/>
export function get() {
    return {
        template: "presenters-labels-default"
    };
}